'use memo';

import {
  AgxDropdown,
  AgxSpacer,
  AgxTypography,
  type DropdownOption,
} from '@urbanx/agx.ui-components2';

interface TaskProgressorSelectorsProps {
  agencyOptions: DropdownOption[];
  campaignOptions: DropdownOption[];
  selectedAgencyId?: string;
  selectedCampaignId?: string;
  isLoadingAgencies: boolean;
  isLoadingCampaigns: boolean;
  isLoadingCampaignDetails: boolean;
  hasLoadError: boolean;
  isPending: boolean;
  onAgencyChange: (agencyId: string) => void;
  onCampaignChange: (campaignId: string) => void;
}

const TaskProgressorSelectors = ({
  agencyOptions,
  campaignOptions,
  selectedAgencyId,
  selectedCampaignId,
  isLoadingAgencies,
  isLoadingCampaigns,
  isLoadingCampaignDetails,
  hasLoadError,
  isPending,
  onAgencyChange,
  onCampaignChange,
}: TaskProgressorSelectorsProps) => (
  <AgxSpacer gap="spacing-md" fill>
    <AgxSpacer gap="spacing-xl" fill>
      <AgxSpacer direction="vertical" style={{ width: '480px', maxWidth: '100%' }}>
        <AgxDropdown
          id="task-progressor-agency"
          label="Agency"
          options={agencyOptions}
          selected={selectedAgencyId}
          onChange={onAgencyChange}
          placeholder={isLoadingAgencies ? 'Loading agencies' : 'Select agency'}
          disabled={isLoadingAgencies || isPending}
          searchable
          searchPlaceholder="Search agencies"
          stretch
          hideOptionalText
        />
      </AgxSpacer>

      <AgxSpacer direction="vertical" style={{ width: '480px', maxWidth: '100%' }}>
        <AgxDropdown
          id="task-progressor-campaign"
          label="Campaign"
          options={campaignOptions}
          selected={selectedCampaignId}
          onChange={onCampaignChange}
          placeholder={isLoadingCampaigns ? 'Loading campaigns' : 'Search by address'}
          disabled={!selectedAgencyId || isLoadingCampaigns || isPending}
          searchable
          searchPlaceholder="Search addresses"
          stretch
          hideOptionalText
        />
      </AgxSpacer>
    </AgxSpacer>

    {hasLoadError && (
      <AgxTypography id="task-progressor-load-error" type="body" size="small">
        Unable to load task progressor data.
      </AgxTypography>
    )}

    {isLoadingCampaignDetails && selectedCampaignId && (
      <AgxTypography id="task-progressor-loading" type="body" size="small">
        Loading campaign details...
      </AgxTypography>
    )}
  </AgxSpacer>
);

export default TaskProgressorSelectors;
